import { render, staticRenderFns } from "./MultipleQuery.vue?vue&type=template&id=3b8b13cd&scoped=true&"
import script from "./MultipleQuery.vue?vue&type=script&lang=js&"
export * from "./MultipleQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b13cd",
  null
  
)

export default component.exports